/**
 * AggregateRating type
 * DOC: https://schema.org/AggregateRating
 */

export const aggregateRating = ({
  name,
  ratingValue,
  reviewCount
}) => {
  if (!name || typeof name === 'undefined') {
    throw new Error('name argument is required');
  }
  return `{
    "@context": "https://schema.org/",
    "@type": "CreativeWorkSeries",
    "name": "${name}",
    "aggregateRating": {
      "@type": "AggregateRating",
      "worstRating": 1,
      "bestRating": 5,
      "ratingCount": ${reviewCount || 0},
      "ratingValue": ${ratingValue || 0}
    }
  }`;
};